module.exports = __webpack_public_path__ + "static/img/product1.97dc4a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/purple/product1.png
// module id = RhND
// module chunks = 0